// extracted by mini-css-extract-plugin
export var sectionTitle = "SeniorAdvisoryBoardNew-module--sectionTitle--jihxZ";
export var seniorAdvisorySection = "SeniorAdvisoryBoardNew-module--seniorAdvisorySection--nfzy5";
export var teamGrid = "SeniorAdvisoryBoardNew-module--teamGrid--ucLMx";